'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.LocalizationService = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); // Configures and synchronizes tmhDynamicLocale and $i18nextProvider.
// Locale codes used are 2-letter ones, like 'fi' (lowercase)

var _module2 = require('./module');

var _module3 = _interopRequireDefault(_module2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LocalizationService = exports.LocalizationService = function () {
    function LocalizationService(defaultLanguage, tmhDynamicLocale, $i18next, $rootScope, $injector) {
        _classCallCheck(this, LocalizationService);

        this.tmhDynamicLocale = tmhDynamicLocale;
        this.$i18next = $i18next;
        this.$rootScope = $rootScope;
        if ($injector.has('$cookies')) {
            this.$cookies = $injector.get('$cookies');
            $rootScope.$on('logout', function () {
                $cookies.remove('culture');
            });
        }

        if (this.$cookies && this.$cookies.get('culture')) {
            this.setLanguageInternal($cookies.get('culture'));
        } else {
            this.setLanguageInternal(defaultLanguage);
        }
    }

    _createClass(LocalizationService, [{
        key: 'setLanguageInternal',
        value: function setLanguageInternal(language) {
            language = language.toLowerCase();

            if (this.language == language) {
                return;
            }

            this.language = language;
            this.$rootScope.language = language;

            // Note that both of these changes trigger load of an external resource.
            this.tmhDynamicLocale.set(this.language);
            this.$i18next.options.lng = this.language;
        }
    }, {
        key: 'setLanguage',
        value: function setLanguage(language) {
            this.setLanguageInternal(language);
            if (this.$cookies) {
                this.$cookies.put('culture', language);
            }
            this.$rootScope.$broadcast('languageChanged', language);
        }
    }, {
        key: 'getLanguage',
        value: function getLanguage() {
            return this.language;
        }
    }]);

    return LocalizationService;
}();

;

_module3.default.provider('localizationService', ['$i18nextProvider', 'tmhDynamicLocaleProvider', function LocalizationServiceProvider($i18nextProvider, tmhDynamicLocaleProvider) {
    var defaultLanguage = 'fi';

    // Custom locale files for specific customers etc.
    var customNamespaces = [];

    tmhDynamicLocaleProvider.localeLocationPattern(__webpack_public_path__ + '/angular-locale_{{locale}}.js');

    // Common translations for all customers. Used when customs don't exist.
    var COMMON_NAMESPACE = 'common';

    $i18nextProvider.options = {
        useCookie: false,
        useLocalStorage: false,

        lng: 'fi',

        // Fallback languages to try, in order.
        fallbackLng: {
            'fi': ['en'],
            'sv': ['fi', 'en'],
            'en': ['fi'],
            'de': ['en', 'fi'],
            'default': ['en', 'fi']
        },

        ns: {
            namespaces: [COMMON_NAMESPACE],
            defaultNs: COMMON_NAMESPACE
        },
        fallbackNS: [],

        resGetPath: __webpack_public_path__ + '/locales/__ns__/__lng__.json',

        defaultLoadingValue: '' // Hide untranslated strings during loading
    };

    this.setDefaultLanguage = function (language) {
        defaultLanguage = language;
        $i18nextProvider.options.lng = language;
    };

    // Add a custom namespace to use. If a translation is not found in the custom
    // namespace, fall back to the common namespace.
    // Multiple namespaces can be added. In that case, they are tried in the order
    // they were added.
    this.addCustomNamespace = function (namespace) {
        customNamespaces.push(namespace);

        var namespaces = _.concat(customNamespaces, COMMON_NAMESPACE);
        $i18nextProvider.options.ns.namespaces = namespaces;
        $i18nextProvider.options.ns.defaultNs = namespaces[0]; // The first namespace is default
        $i18nextProvider.options.fallbackNS = _.slice(namespaces, 1); // All others are fallbacks

        console.log('[LocalizationService] Added custom namespace', namespace);
    };

    this.$get = ['tmhDynamicLocale', '$i18next', '$injector', '$rootScope', function (tmhDynamicLocale, $i18nextProvider, $injector, $rootScope) {
        return new LocalizationService(defaultLanguage, tmhDynamicLocale, $i18nextProvider, $rootScope, $injector);
    }];
}]);


//////////////////
// WEBPACK FOOTER
// ./src/core/localizationService.js
// module id = 29
// module chunks = 0 2